<span>{{property.name}}</span><span class="after">{{afterProperty}}&nbsp;</span>
<be-input placeholder="" [formGroup]="formGroup" controlName="control" [property]="property"></be-input>
